
import React, { Component } from 'react';
import './cw-question-viewer.scss'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import Latex from "react-latex";
import { InlineMath, BlockMath } from 'react-katex'
import MathJax from "react-mathjax2"
import CwContentViewer from '../cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../canvas/canvas'
import GeometryTranspiler from '../geometry/geometry-parser'


class Contents extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        activeTabIndex: []
    }

    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    onClickTab = (id ,val) => {
        const {activeTabIndex} = this.state
        activeTabIndex[id] = val
        this.setState({
            activeTabIndex
        })
    }

    renderContentType = (contentType, content) => {
        const {activeTabIndex} = this.state
        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div >
                            {!content.content.isMultiStep && content.content.options.map((item, index) =>
                                <div className='mb-2 ml-1 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='radio-btn'></div>
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}
                            <>
                                <div className='tab-container'>
                                    <div className='tab-inner-container'>
                                        {content.content.isMultiStep && content.content.steps.map((step, index) => (
                                        
                                                    <div
                                                        key={'tab0'}
                                                        className={`tab mr-3 ${(!activeTabIndex[content.id] && index === 0) || (activeTabIndex[content.id] == index) ? 'tab-active' : ''}`}
                                                        onClick={() => this.onClickTab(content.id, index)}
                                                    >
                                                        <div className='tab-center'>
                                                            <span>Branch Qs {index + 1}</span>
                                                        </div>
                                                        {(!activeTabIndex[content.id] && index === 0) || (activeTabIndex[content.id] == index) ? <div className='active-cirlce'></div> : ''}
                                                    </div>
                                                
                                        ))}
                                    </div>
                                </div>
                            </>
                            {content.content.isMultiStep && content.content.steps.map((step, index) => (
                                <>
                                    {((!activeTabIndex[content.id] && index === 0) ||
                                        (activeTabIndex[content.id] == index)) && (
                                        <>
                                            <div className='qn-title'><CwContentViewer content={step.content.title} /></div>
                                            {step.content.options.map((item, index) => (
                                                <div className='mb-2 ml-1 row sequence-option'>
                                                    <div className='col-2 '>
                                                        <div className='radio-btn'></div>
                                                    </div>
                                                    <div className='col 6'>
                                                        {item.contentTypeName == 'TEXT' ? (
                                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                                            <CwContentViewer content={item.content} />
                                                        ) : (
                                                            <div className=''>
                                                                <img
                                                                className='image-option-container'
                                                                src={item.content}
                                                                alt=''
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </>
                                ))}
                        </div>
                    </div>

                )

            case 2:
                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-1 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='check-box'></div>
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 4:
                return (

                    <div>
                        <div className='row'>
                            {content.content.options.map((item, index) =>
                                <>
                                    <div className='col-5 matching-option pt-2'>
                                        {
                                            item.question.contentTypeName == 'TEXT' ?
                                                // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                                <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                                :
                                                <div className='match-option'>
                                                    <img className='image-option-container' src={item.question.content} alt="" />
                                                </div>
                                        }
                                    </div>
                                    <div className="col-1 pt-2 my-auto">
                                        <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.ARROW_HORIZONTAL)} /></div>
                                    </div>
                                    <div className="col-6 pt-2">
                                        {item.answer.contentTypeName == 'TEXT' ?
                                            // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                            <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                            :
                                            <div className='match-option'>
                                                <img className='image-option-container' src={item.answer.content} alt="" />
                                            </div>
                                        }
                                    </div>
                                </>
                            )}

                        </div>
                    </div >

                )

            case 5:

                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col 6 '>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className="pl-2">
                        <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
                                    // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div>
                        <div className='row mt-4'>
                            {content.content.options.map((item, index) =>
                                <div className='ml-2 group-option'>
                                    <div className='group-header px-3'>
                                        {/* <div className='text-center mt-2' dangerouslySetInnerHTML={{ __html: item.title }} /> */}
                                        <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                )

            case 10:
                if (content?.content?.canvas?.render?.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        payload.length ?
                            <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                            : ""
                    )
                }

            default:
                return ("")
        }

    }


    render() {
        return <div className="cw-question-viewer">{this.renderContentType(this.props.type, this.props.question)}</div>
    }
}

export default Contents;